import { Toaster } from "@/components/ui/sonner";
import Navbar from "@/components/site/Navbar";
import Footer from "@/components/site/Footer";
import CookieBanner from "@/components/site/CookieBanner";

export default function Layout({ children }) {
  return (
    <div className="App grain relative overflow-x-clip min-h-screen flex flex-col">
      <Navbar />
      <main className="flex-1">{children}</main>
      <Footer />
      <CookieBanner />
      <Toaster richColors position="top-center" />
    </div>
  );
}
